import { SxProps } from '@mui/material';
import { black, grey5 } from 'app/components/ThemeProvider/colors';

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '28px',
  width: '325px',
  fontWeight: '600',

  '@media screen and (max-height: 864px)': {
    mb: '12px',
  },
};

export const tabs: SxProps = {
  width: '100%',
  mb: '28px',
  '& .MuiTabs-scroller': { pb: '10px' },
};

export const tab: SxProps = {
  fontFamily: 'Yelo',
  fontWeight: '400',
  fontSize: '14px',
  color: grey5,
  // width: 'calc(100% / 3)',
  width: 'calc(100% / 2)',

  '&.Mui-selected': {
    color: black,
  },
};
